module.exports = __webpack_public_path__ + "media/images/FreePreviewSplash-d2250cc9a10ffe32254cef793cb26153.png";